<template>
    <common-layout class="default-no-header-layout" />
</template>

<script setup lang="ts">
    import CommonLayout from "./common.vue";
</script>
